import { Grid, Typography, Paper } from '@material-ui/core'
import { FC } from 'react'
import i18n from '../../../../translations/i18n'
import { ReserveInterface } from '../../../../types/states'

interface StatusInfoProps {
  reserve: ReserveInterface
}

const StatusInfoText = ({ text }: { text: string }) => (
  <Typography variant='h5' gutterBottom style={{ textAlign: 'center' }}>
    {i18n.t(text)}
  </Typography>
)

/** reserved can either be boolean (true, false) or reserved showing object */
const StatusInfo: FC<StatusInfoProps> = ({
  reserve: {
    reserveViewLogic: { error }
  }
}) => {
  const notAllowed = error === '409' || error === '403'
  const unknownError = error !== '409' && error !== '403' && error !== '404'
  const notAvailable = error === '404'

  return (
    <Grid item xs={8}>
      <Paper style={{ margin: '50px 0', padding: '30px' }}>
        {notAllowed && <StatusInfoText text='showings.reserve.notAllowed' />}
        {unknownError && !notAllowed && (
          <StatusInfoText text='showings.reserve.unknownError' />
        )}
        {!unknownError && !notAllowed && notAvailable && (
          <StatusInfoText text='showings.reserve.notAvailable' />
        )}
      </Paper>
    </Grid>
  )
}

export default StatusInfo
